import { Workspace } from '@/types/generated/graphql';
import { AppAvatar } from '@components/app-avatar';
import { centsToDollar } from '@modules/settings/subscription/utils/utils';
import { getFormattedPrice } from '@shared/utils/price-utils';
import { Badge, Tooltip } from 'antd';
import { RiCheckFill } from 'react-icons/ri';

export function WorkspaceItem({ workspace }: { workspace: Workspace }) {
  const isCurrent = workspace?.isCurrent;
  return (
    <div className="flex justify-between h-9 font-medium items-center">
      <div className="flex items-center gap-2">
        <AppAvatar
          className="border-gray-500! size-5! [&_span]:text-xs!"
          // style={{ border: 'solid var(--color-gray-400)' }}
          src={workspace?.logo?.url}
          name={workspace?.label}
        />
        <span className="text-sm text-text-600">
          {workspace.label?.slice(0, 13)}
          <Tooltip title={workspace?.label}>{workspace?.label && workspace?.label.length > 14 && '...'}</Tooltip>
        </span>
        <Badge count={workspace?.unreadCountWorkspace} style={{ boxShadow: 'unset' }} />
      </div>

      {isCurrent ? (
        <div className="bg-primary text-white size-4 rounded-full flex justify-center items-center">
          <RiCheckFill className="size-3.5" />
        </div>
      ) : (
        <p className="text-xs font-normal">{getFormattedPrice(centsToDollar(workspace?.availableBalance))}</p>
      )}
    </div>
  );
}
